// @flow

import * as React from 'react';

type Props = {
  width?: string,
  height?: string,
  color?: string,
};

export const Information = ({ width, height, color }: Props) => (
  <svg
    viewBox="0 0 24 24"
    width={width || '100%'}
    height={height || '100%'}
    style={{ fill: color || 'currentColor' }}
  >
    <path d="M10.98 4.45c0-.405.14-.747.422-1.028A1.402 1.402 0 0 1 12.432 3c.404 0 .747.14 1.028.422.282.28.423.623.423 1.027 0 .405-.141.747-.423 1.028a1.402 1.402 0 0 1-1.029.422c-.405 0-.748-.14-1.03-.422a1.398 1.398 0 0 1-.422-1.028zm.369 13.045c-.14.79-.172 1.309-.092 1.555.079.246.286.369.62.369.352 0 .69-.15 1.016-.448.325-.299.69-.703 1.095-1.213l.74.528c-.529.878-1.06 1.55-1.598 2.016-.536.465-1.218.698-2.045.698-.669 0-1.179-.18-1.53-.54-.353-.36-.45-1.015-.291-1.964l1.425-8.618H9l.158-.922 3.669-.606-1.478 9.145z" />
  </svg>
);
